<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else class="container">
      <h1 class="screen-title">Events</h1>
      <div>
        <v-tabs v-model="tab" slider-color="transparent" height="36" class="tabs">
          <v-tab class="tab">Live</v-tab>
          <v-tab class="tab">Past</v-tab>
        </v-tabs>
        <div v-if="tab === 0" class="event-container">
          <event-card
            v-for="event in liveEvents"
            :key="event.id"
            :event="event"
            :organization-slug="event.organization.slug"
            :organization-type="event.organization.type"
          />
        </div>
        <div v-else class="event-container">
          <event-card
            v-for="event in pastEvents"
            :key="event.id"
            :event="event"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { GET_WORKING_EVENTS } from '../../graphql/event.graphql'

import eventCard from './event-card.vue'

export default {
  name: 'home',
  components: { eventCard },
  data() {
    return {
      events: [],
      tab: null,
      organization: null,
    }
  },
  computed: {
    pastEvents() {
      return this.events
        .filter(({ to }) => {
          return moment(to).isBefore(moment())
        })
        .sort((event1, event2) => new Date(event2.to) - new Date(event1.to))
    },
    liveEvents() {
      return this.events
        .filter(({ to }) => {
          return moment(to).isAfter(moment())
        })
        .sort((event1, event2) => new Date(event1.from) - new Date(event2.from))
    },
  },
  methods: {
    handleBeforeEventSelect(event) {
      this.goTo(
        event.extraModules.ticketing
          ? this.routes.main.organizerSidebar
          : this.routes.organizer.accreditations,
        { organizationSlug: event.organization.slug, eventId: event.id },
      )
    },
  },
  apollo: {
    getWorkingEvents: {
      query: GET_WORKING_EVENTS,
      result({ data: { getWorkingEvents }, loading }) {
        if (!loading) {
          this.events = getWorkingEvents || []
        }
      },
    },
  },
}
</script>

<style scoped>
.screen-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 800;
  flex-basis: 15%;
  font-size: 3rem;
  align-self: flex-start;
  width: 13.25rem;
  color: #ff4c00;
  margin-right: 3rem;
}
p {
  display: inline;
}
.tab {
  font-family: 'Raleway', sans-serif;
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.5;
}

.tab >>> .v-tabs__item {
  padding: 0.375rem 0.75rem;
  color: #0277bd;
}

.tab >>> .v-tabs__item--active {
  background: #0277bd;
  border-radius: 0.5rem;
  color: white;
}

.tabs >>> .v-tabs__container {
  flex: 0 1 auto;
  background: #f0f6fa;
  border-radius: 0.5rem;
}
.event-container {
  display: flex;
  flex-direction: column;
  max-width: 42.75rem;
  gap: 1rem;
}
@media screen and (max-width: 500px) {
  .event-container {
    gap: 0;
  }
}
.container {
  display: flex;
  justify-content: center;
}
.tabs {
  margin-bottom: 1.5rem;
  padding-top: 1.25rem;
}
@media screen and (max-width: 801px) {
  .container {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .screen-title {
    margin-bottom: 1.5rem;
    padding: 0 !important;
  }
  .tabs {
    padding-top: 0 !important;
  }
}
</style>
